var exports = {
  "R": "colorIndicator__ctUuf1",
};

module.exports = exports;
